import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getNarsStudioUrl } from "./studioUrl";

export const NarsStudioLink = ({ compact = false }: { compact?: boolean }) => {
  const url = getNarsStudioUrl(
    import.meta.env.VITE_NARS_STUDIO_URL,
    window.location.hostname,
  );

  if (!url) {
    return (
      <Button
        variant="ghost"
        size={compact ? "icon" : "sm"}
        title="Configura un indirizzo web di NARS raggiungibile da questo dispositivo."
        disabled
      >
        <span className={compact ? "sr-only" : undefined}>
          Collegamento NARS da configurare
        </span>
        <ArrowUpRight className="size-4" aria-hidden="true" />
      </Button>
    );
  }

  return (
    <Button asChild variant="outline" size={compact ? "icon" : "sm"}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Apri NARS (nuova scheda)"
        title="Apri il tool creativo NARS in una nuova scheda. Deve essere avviato sul tuo computer."
      >
        <span className={compact ? "sr-only" : undefined}>Apri NARS</span>
        <ArrowUpRight className="size-4" aria-hidden="true" />
      </a>
    </Button>
  );
};
